import axios from 'axios';
import apiConfig from '../config/apiConfig';

const BASE_URL = apiConfig.BASE_URL;

function getStoredToken() {
  try {
    const persistRoot = localStorage.getItem('persist:root');
    if (persistRoot) {
      const parsed = JSON.parse(persistRoot);
      if (parsed.auth) {
        const authState = JSON.parse(parsed.auth);
        return authState.token;
      }
    }
  } catch (e) {
    console.warn('Could not read token from redux-persist:', e);
  }
  return localStorage.getItem('storehub_token') || sessionStorage.getItem('storehub_token');
}

function getAuthHeaders() {
  const token = getStoredToken();
  if (!token || token === 'null' || token === 'undefined') {
    throw new Error('Authentication required. Please log in again.');
  }
  return { headers: { Authorization: `Bearer ${token}` } };
}

export const fetchTickets = async (params) => {
  const auth = getAuthHeaders();
  const response = await axios.get(`${BASE_URL}/api/support/tickets`, { ...auth, params: params || {} });
  return response.data;
};

export const createTicket = async (payload) => {
  const auth = getAuthHeaders();
  const response = await axios.post(`${BASE_URL}/api/support/tickets`, payload, auth);
  return response.data;
};

export const getTicketById = async (id) => {
  const auth = getAuthHeaders();
  const response = await axios.get(`${BASE_URL}/api/support/tickets/${id}`, auth);
  return response.data;
};

export const updateTicket = async (id, payload) => {
  const auth = getAuthHeaders();
  const response = await axios.put(`${BASE_URL}/api/support/tickets/${id}`, payload, auth);
  return response.data;
};

export const addTicketReply = async (id, message) => {
  const auth = getAuthHeaders();
  const response = await axios.post(`${BASE_URL}/api/support/tickets/${id}/replies`, { message }, auth);
  return response.data;
};

export const fetchArticles = async (params) => {
  const auth = getAuthHeaders();
  const response = await axios.get(`${BASE_URL}/api/support/articles`, { ...auth, params: params || {} });
  return response.data;
};

export const fetchArticleById = async (id) => {
  const auth = getAuthHeaders();
  const response = await axios.get(`${BASE_URL}/api/support/articles/${id}`, auth);
  return response.data;
};

export const fetchForumCategories = async () => {
  const auth = getAuthHeaders();
  const response = await axios.get(`${BASE_URL}/api/support/forum/categories`, auth);
  return response.data;
};

export const fetchForumPosts = async (params) => {
  const auth = getAuthHeaders();
  const response = await axios.get(`${BASE_URL}/api/support/forum/posts`, { ...auth, params: params || {} });
  return response.data;
};

export const fetchForumPostById = async (id) => {
  const auth = getAuthHeaders();
  const response = await axios.get(`${BASE_URL}/api/support/forum/posts/${id}`, auth);
  return response.data;
};

export const createForumPost = async (payload) => {
  const auth = getAuthHeaders();
  const response = await axios.post(`${BASE_URL}/api/support/forum/posts`, payload, auth);
  return response.data;
};

export const createForumReply = async (postId, payload) => {
  const auth = getAuthHeaders();
  const response = await axios.post(`${BASE_URL}/api/support/forum/posts/${postId}/replies`, payload, auth);
  return response.data;
};
